import React from 'react';

/**
 * TooltipSvg Component
 *
 * A presentational component for rendering the visual structure of a tooltip, including:
 * - A rounded rectangle background.
 * - A triangular arrow that adjusts its position dynamically.
 * - The tooltip text rendered as a child inside the tooltip.
 *
 * Props:
 * - `width` (number): The width of the tooltip, including the background.
 * - `height` (number): The height of the tooltip, excluding the arrow.
 * - `arrowX` (number): The horizontal position of the arrow relative to the tooltip.
 * - `arrowSize` (number): The size of the arrow, which affects its height and width.
 * - `text` (string): The content displayed inside the tooltip.
 */
const TooltipSvg = ({ width, height, arrowX, arrowSize, text }) => {
  const totalHeight = height + arrowSize;

  return (
    <svg
      width={width}
      height={totalHeight}
      viewBox={`0 0 ${width} ${totalHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="tooltip-svg"
    >
      {/* Tooltip background */}
      <rect x="0" y="0" width={width} height={height} rx="20" ry="8" fill="#697077" />
      {/* Tooltip arrow */}
      <polygon
        points="0,0 20,10 40,0"
        fill="#697077"
        transform={`translate(${arrowX}, ${height - 2})`}
        data-testid="tooltip-arrow"
      />
      {/* Tooltip text */}
      <foreignObject x="0" y="0" width={width} height={height}>
        <div className="tooltip-text">{text}</div>
      </foreignObject>
    </svg>
  );
};

export default TooltipSvg;
